import React, { useEffect, useState } from "react";
import {
  TableContainer,
  Paper,
  Button,
  TextField,
  MenuItem,
  Box,
} from "@mui/material";
import { Link } from "react-router-dom";

// material-ui
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
} from "@mui/material";
import { Get_All_From_MongoDB } from "../../../api/Get_All_From_MongoDB";
import { Post_To_MongoDB } from "../../../api/Post_To_MongoDB";
import { Update_To_MongoDB_By_ID } from "../../../api/Update_To_MongoDB_By_ID";
import SimpleTableHeader from "../../../components/Tables/SimpleTableHeader";
import DisplayExport from "../../../components/Exports/DisplayExport";
import { StaffuseAuth } from "../../../security/StaffuseAuth";
import getNameByID from "../../../../functions/getNameByID";
import SimpleTableCell from "../../../components/Tables/SimpleTableCell";
import SearchSetInvoices from "../../../components/Search/SearchSetInvoices";
import { Send_TCS_Certificate } from "../api/Send_TCS_Certificate";
// material-ui

function TCSCertificates() {
  const { logout } = StaffuseAuth();

  const [TCS, setTCS] = useState([]);

  useEffect(() => {
    Get_All_From_MongoDB("Emails", "TCS", setTCS, logout);
  }, []);

  //Get all distinct values from an array of objects, specifically the "Group" field

  let distinctValues = [];
  TCS.forEach((TCS) => {
    if (!distinctValues.includes(TCS.Group)) {
      distinctValues.push(TCS.Group);
    }
  });
  console.log(distinctValues);

  const [chosenGroup, setChosenGroup] = useState("");
  function handleChoosechosenGroup(event) {
    setChosenGroup(event.target.value);
  }

  //filter TCS by chosenGroup
  let TCSFiltered = TCS;
  if (chosenGroup !== "") {
    TCSFiltered = TCS.filter((TCS) => TCS.Group === chosenGroup);
  }

  function handleSend(Student, e) {
    e.preventDefault();
    Send_TCS_Certificate(Student, logout);
  }

  const [allowSendAll, setallowSendAll] = useState("");

  function handleAllowSendAll(e) {
    e.preventDefault();
    setallowSendAll("Yes");
  }

  function handleSendAll(e) {
    e.preventDefault();
    TCSFiltered.forEach((Student) => {
      Send_TCS_Certificate(Student, logout);
    });
  }

  return (
    <div
      style={{
        backgroundColor: "#e5e5e5",
        minHeight: "93vh",
        paddingLeft: "10px",
      }}
    >
      <section>
        <h1 style={{ marginTop: "0px" }}>Emails</h1>
        <h2>TCS</h2>
        <DisplayExport excelData={TCS} fileName="TCS" />
        <Box
          component="main"
          sx={{
            display: "flex",
            flexDirection: "column",
            alignItems: "flex-start",
            maxWidth: "5%",
            maxHeight: "100px",
            Height: "100px",
            flexGrow: 1,
            p: 1,
          }}
        >
          <button onClick={(e) => handleAllowSendAll(e)}>Allow Send ALL</button>{" "}
        </Box>
        {allowSendAll === "Yes" ? (
          <Box
            component="main"
            sx={{
              display: "flex",
              flexDirection: "column",
              alignItems: "flex-start",
              maxWidth: "5%",
              maxHeight: "100px",
              Height: "100px",
              flexGrow: 1,
              p: 1,
            }}
          >
            <button onClick={(e) => handleSendAll(e)}>
              Send ALL... check your filter
            </button>{" "}
          </Box>
        ) : (
          <></>
        )}
        <br></br>
        <TextField
          label="Chosen Group"
          name="chosenGroup"
          variant="outlined"
          margin="normal"
          value={chosenGroup}
          onChange={handleChoosechosenGroup}
          fullWidth
          sx={{ marginBottom: "10px" }}
          select
          InputProps={{
            style: {
              backgroundColor: "white",
            },
          }}
        >
          <MenuItem key={""} value={""}>
            NULL
          </MenuItem>
          {distinctValues.map((distinctValue) => (
            <MenuItem key={distinctValue} value={distinctValue}>
              {distinctValue}
            </MenuItem>
          ))}
        </TextField>
        <br></br>
        <section>
          <TableContainer
            component={Paper}
            sx={{
              width: "100%",
              margin: "0 auto",
              overflow: "auto",
            }}
          >
            <Table
              aria-label="simple table"
              sx={{
                border: "1px solid #e0e0e0",
                tableLayout: "fixed",
              }}
            >
              <TableHead>
                <TableRow>
                  {SimpleTableHeader("ID")}
                  {SimpleTableHeader("Email")}
                  {SimpleTableHeader("CC")}
                  {SimpleTableHeader("Name")}
                  {SimpleTableHeader("Distinction")}
                  {SimpleTableHeader("Note")}
                  {SimpleTableHeader("Notes")}
                  {SimpleTableHeader("Group")}
                  {SimpleTableHeader("School")}
                  {SimpleTableHeader("Score")}
                  {SimpleTableHeader("Strength")}
                  {SimpleTableHeader("Weak")}
                </TableRow>
              </TableHead>
              <TableBody>
                {TCSFiltered && Array.isArray(TCSFiltered) ? (
                  TCSFiltered.map((Student, index) => (
                    <TableRow
                      key={index}
                      sx={{
                        "&:hover": {
                          backgroundColor: "rgba(169, 169, 169, 0.8)", // Dark grey color
                          "& .MuiTableCell-root": {
                            padding: "8px",
                            wordWrap: "break-word",
                            overflowWrap: "break-word", // Adjust padding here to make cells smaller
                          },
                        },
                        backgroundColor: "inherit",
                      }}
                    >
                      {SimpleTableCell(Student._id)}
                      {SimpleTableCell(Student.Email)}
                      {SimpleTableCell(Student.EmailCC)}
                      {SimpleTableCell(Student.Name)}
                      {SimpleTableCell(Student.Distinction)}
                      {SimpleTableCell(Student.Note)}
                      {SimpleTableCell(Student.Notes)}
                      {SimpleTableCell(Student.Group)}
                      {SimpleTableCell(Student.School)}
                      {SimpleTableCell(Student.Score)}
                      {SimpleTableCell(Student.Strength)}
                      {SimpleTableCell(Student.Weak)}
                      <TableCell
                        component="th"
                        scope="row"
                        sx={{
                          padding: "8px",
                          wordWrap: "break-word",
                          overflowWrap: "break-word",
                        }}
                      >
                        <button onClick={(e) => handleSend(Student, e)}>
                          Send
                        </button>
                      </TableCell>
                    </TableRow>
                  ))
                ) : (
                  <></>
                )}
              </TableBody>
            </Table>
          </TableContainer>
        </section>
        <div style={{ marginTop: "20px" }}></div>
      </section>
    </div>
  );
}

export default TCSCertificates;
